import * as L from 'leaflet';
import { MAP_FOCUS_COLOR, MAP_FOCUS_DASH_ARRAY } from './map-object-focus';

export const PIN_WIDTH = 32;
export const PIN_HEIGHT = 32;
export const PIN_PATH = 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Z';

export function focusPinIcon(): L.DivIcon {
  return L.divIcon({
    className: 'map-object-focus-pin',
    html: `<svg width="32" height="32" viewBox="0 0 24 24" aria-hidden="true"><path d="${PIN_PATH}" fill="none" stroke="${MAP_FOCUS_COLOR}" stroke-width="2" stroke-dasharray="${MAP_FOCUS_DASH_ARRAY}" stroke-linecap="butt" vector-effect="non-scaling-stroke"/></svg>`,
    iconSize: [PIN_WIDTH, PIN_HEIGHT], iconAnchor: [PIN_WIDTH / 2, PIN_HEIGHT],
  });
}

/** Ordinary business-location pin, shared by map features and record previews. */
export function placePinIcon(color: string, selected = false): L.DivIcon {
  return L.divIcon({
    className: `map-feature-marker-icon${selected ? ' is-selected' : ''}`,
    html: [
      `<svg class="map-feature-marker-pin" viewBox="0 0 24 24" style="--map-feature-color:${color}" aria-hidden="true">`,
      `<path class="map-feature-marker-pin__selection-outline" d="${PIN_PATH}"/>`,
      `<path class="map-feature-marker-pin__body" d="${PIN_PATH}"/>`,
      '<circle class="map-feature-marker-pin__center" cx="12" cy="9" r="2.5"/>',
      '</svg>',
    ].join(''),
    iconSize: [PIN_WIDTH, PIN_HEIGHT],
    iconAnchor: [PIN_WIDTH / 2, PIN_HEIGHT],
  });
}
